import IMask from "imask";
import ImaskController from "./imask_controller";
import { currencySymbols } from "../../utils/createNumberPipe";

export default class extends ImaskController {
  static values = {
    currency: String
  };

  declare currencyValue: string;

  currencyValueChanged() {
    if (this.element.imask && this.element.imaskOptions) {
      this.element.imaskOptions.mask = `${this.currencyValue} num`;
      this.element.imask = IMask(this.element, this.element.imaskOptions);
    }
  }

  handleCurrencyChanged(event: CustomEvent) {
    let symbol = event.detail.currency;
    if (currencySymbols[symbol]) {
      symbol = currencySymbols[symbol];
    }
    this.currencyValue = symbol;
  }
}
